<template>
  <div :class="$style.snackContainer">
    <transition-group
      :enter-active-class="$style.enterActive"
      :enter-from-class="$style.enterFrom"
      :leave-active-class="$style.leaveActive"
      :leave-to-class="$style.leaveTo"
      :move-class="$style.move"
      appear
    >
      <SnackProvider v-for="snack in snacks" :key="snack.id" :class="$style.snackProvider" :snack="snack">
        <component
          :is="snack.component"
          :key="snack.id"
          :class="$style.snack"
          v-bind="snack.props"
          v-on="snack.listeners"
        />
      </SnackProvider>
    </transition-group>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { SnackProvider, useSnackbar } from "vue-haystack";

const store = useSnackbar();

const snacks = computed(() => {
  return store.items.value;
});
</script>

<style module lang="scss">
.snackContainer {
  z-index: 600;
  position: fixed;

  bottom: var(--space-component-padding-xLarge);
  right: 0;
  left: 0;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: var(--space-component-gap-small);
  pointer-events: none;

  .snackProvider {
    .snack {
      pointer-events: all;
    }
  }
}

@include Globals.toast-transitions;
</style>
